// import React, { useState, useEffect } from 'react';
// import {  useNavigate } from 'react-router-dom';
// import { useCookies } from 'react-cookie';
// import {  API_ENDPOINT_USER } from '../auth/config';
// import './CookieConsent.css'; // อย่าลืมสร้างไฟล์ CSS เพื่อการจัดการรูปแบบ

// const CookieConsent = () => {
//   const [cookies, setCookie] = useCookies(['cookieConsent']);
//   const [showPopup, setShowPopup] = useState(false);
//   const [agreementText, setAgreementText] = useState('');
//   const userid = localStorage.getItem('userid');
//   const navigate = useNavigate();
  
//   useEffect(() => {
//     chack_cookie();
//     c();
  
//   }, [cookies.cookieConsent]);

 
//   const c = async () => {
//     const requestOptions = {
//       method: "POST",
//       redirect: "follow",
//     };
  
//     try {
//       const response = await fetch(`https://addpay.net/e-member/public/api/user_condition`, requestOptions);
//       const data = await response.json();
      
//       console.log(data.agreement_text); // ลบ await ออก
//       setAgreementText(data.agreement_text);
  
//       // ตรวจสอบว่ามีคุกกี้ที่บันทึกการยินยอมแล้วหรือไม่
//       // if (!cookies.cookieConsent) {
//       //   setShowPopup(true);
//       // }
//     } catch (error) {
//       console.error('Error fetching data:', error);
//     }
//   };
//   const chack_cookie = () =>{
//     setShowPopup(true);

//   }

//   const handleAccept = () => {
//     setCookie('cookieConsent', 'accepted', { path: '/' });
//     const myHeaders = new Headers();
//     myHeaders.append("Content-Type", "application/json");

//     const raw = JSON.stringify({
//       "user_id": userid,
//       "action": "insert"
//     });

//     const requestOptions = {
//       method: "POST",
//       headers: myHeaders,
//       body: raw,
//       redirect: "follow"
//     };

//     fetch(`${API_ENDPOINT_USER}/e-member/public/api/user_agreement`, requestOptions)
//       .then((response) => response.json())
//       .then((result) => {
//         console.log(result)
//         setShowPopup(false)
//       })
//       .catch((error) => console.error(error));
//     // setShowPopup(false); // ปิด popup หลังจากการยินยอม
//   };

//   const handleDecline = () => {
//     setCookie('cookieConsent', 'declined', { path: '/' });
//     navigate('/Home');
//     // setShowPopup(false); // ปิด popup หลังจากการปฏิเสธ
//   };

//   return (
//     showPopup && (
//       <div className="cookie-consent-overlay">
//         <div className="cookie-consent-popup">

//           <div dangerouslySetInnerHTML={{ __html: agreementText }} />

//           <div className="cookie-consent-buttons">
//             <button onClick={handleAccept}>ยินยอม</button>
//             <button onClick={handleDecline}>ไม่ยินยอม</button>
//           </div>
//         </div>
//       </div>
//     )
//   );
// };

// export default CookieConsent;



import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useCookies } from 'react-cookie';
import { API_ENDPOINT_USER } from '../auth/config';

/* ── inline styles (ไม่ต้องใช้ CookieConsent.css แยก) ── */
const css = `
  @import url('https://fonts.googleapis.com/css2?family=Sarabun:wght@300;400;500;600;700&family=Libre+Baskerville:wght@700&display=swap');

  /* ── OVERLAY ── */
  .cc-overlay {
    position: fixed;
    inset: 0;
    z-index: 9999;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    background: rgba(10, 14, 26, 0.72);
    backdrop-filter: blur(6px);
    -webkit-backdrop-filter: blur(6px);
    animation: cc-fade-in 0.35s ease forwards;
    padding: 0;
  }

  @keyframes cc-fade-in {
    from { opacity: 0; }
    to   { opacity: 1; }
  }

  /* ── SHEET ── */
  .cc-sheet {
    width: 100%;
    max-width: 680px;
    background: #ffffff;
    border-radius: 24px 24px 0 0;
    box-shadow: 0 -12px 60px rgba(0,0,0,0.22);
    display: flex;
    flex-direction: column;
    max-height: 86vh;
    animation: cc-slide-up 0.42s cubic-bezier(0.22,1,0.36,1) forwards;
    overflow: hidden;
  }

  @keyframes cc-slide-up {
    from { transform: translateY(100%); opacity: 0.6; }
    to   { transform: translateY(0);   opacity: 1; }
  }

  /* ── DRAG HANDLE ── */
  .cc-handle {
    display: flex;
    justify-content: center;
    padding: 14px 0 4px;
    flex-shrink: 0;
  }

  .cc-handle span {
    display: block;
    width: 44px;
    height: 4px;
    border-radius: 4px;
    background: #e2e8f0;
  }

  /* ── HEADER ── */
  .cc-header {
    padding: 14px 28px 18px;
    border-bottom: 1px solid #f1f5f9;
    flex-shrink: 0;
  }

  .cc-badge {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    background: #f0fdf4;
    border: 1px solid #bbf7d0;
    color: #15803d;
    font-size: 0.7rem;
    font-weight: 600;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    padding: 4px 10px;
    border-radius: 100px;
    margin-bottom: 10px;
  }

  .cc-badge svg { width: 12px; height: 12px; }

  .cc-title {
    font-size: 1.35rem;
    color: #0f172a;
    margin: 0 0 4px;
    line-height: 1.3;
  }

  .cc-subtitle {
    font-size: 0.83rem;
    color: #64748b;
    font-weight: 400;
    line-height: 1.5;
  }

  /* ── BODY ── */
  .cc-body {
    flex: 1;
    overflow-y: auto;
    padding: 20px 28px;
    -webkit-overflow-scrolling: touch;
    scroll-behavior: smooth;
  }

  .cc-body::-webkit-scrollbar { width: 4px; }
  .cc-body::-webkit-scrollbar-track { background: transparent; }
  .cc-body::-webkit-scrollbar-thumb { background: #e2e8f0; border-radius: 4px; }

  /* content ที่มาจาก dangerouslySetInnerHTML */
  .cc-body h1, .cc-body h2, .cc-body h3 {
    font-weight: 700;
    color: #1e293b;
    margin: 16px 0 8px;
  }
  .cc-body h2 { font-size: 1rem; }
  .cc-body h3 { font-size: 0.9rem; }
  .cc-body p  { font-size: 0.88rem; color: #475569; line-height: 1.75; margin: 0 0 12px; }
  .cc-body ul, .cc-body ol { padding-left: 18px; margin: 0 0 12px; }
  .cc-body li { font-size: 0.85rem; color: #475569; line-height: 1.7; }
  .cc-body strong { color: #1e293b; font-weight: 600; }
  .cc-body a { color: #2563eb; text-decoration: underline; }

  /* SCROLL FADE INDICATOR */
  .cc-scroll-hint {
    text-align: center;
    font-size: 0.72rem;
    color: #94a3b8;
    padding: 6px 0 2px;
    letter-spacing: 0.04em;
    flex-shrink: 0;
  }

  /* ── FOOTER ── */
  .cc-footer {
    padding: 16px 28px 28px;
    background: #ffffff;
    border-top: 1px solid #f1f5f9;
    flex-shrink: 0;
  }

  .cc-footer-note {
    font-size: 0.75rem;
    color: #94a3b8;
    text-align: center;
    margin-bottom: 14px;
    line-height: 1.5;
  }

  .cc-footer-note strong { color: #64748b; }

  .cc-btns {
    display: flex;
    gap: 10px;
  }

  .cc-btn-accept {
    flex: 1;
    padding: 14px;
    background: linear-gradient(135deg, #22c55e 0%, #16a34a 100%);
    border: none;
    border-radius: 14px;
    color: #ffffff;
    font-size: 1rem;
    font-weight: 700;
    cursor: pointer;
    transition: transform 0.15s, box-shadow 0.15s;
    box-shadow: 0 4px 16px rgba(34,197,94,0.35);
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
  }

  .cc-btn-accept:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 28px rgba(34,197,94,0.45);
  }

  .cc-btn-accept:active { transform: translateY(0); }

  .cc-btn-accept svg { width: 18px; height: 18px; }

  .cc-btn-decline {
    flex: 0 0 auto;
    padding: 14px 20px;
    background: transparent;
    border: 1.5px solid #e2e8f0;
    border-radius: 14px;
    color: #94a3b8;
    font-size: 0.9rem;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.15s;
    white-space: nowrap;
    display: flex;
    align-items: center;
    gap: 6px;
  }

  .cc-btn-decline:hover {
    border-color: #fca5a5;
    color: #ef4444;
    background: #fff5f5;
  }

  /* ── MOBILE ── */
  @media (max-width: 480px) {
    .cc-sheet { border-radius: 20px 20px 0 0; max-height: 92vh; }
    .cc-header { padding: 12px 18px 14px; }
    .cc-title  { font-size: 1.1rem; }
    .cc-body   { padding: 16px 18px; }
    .cc-footer { padding: 12px 18px 24px; }
    .cc-btn-accept  { font-size: 0.95rem; padding: 13px; }
    .cc-btn-decline { font-size: 0.82rem; padding: 13px 14px; }
  }
`;

/* ── ICONS ── */
const ShieldIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
  </svg>
);

const CheckIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="20 6 9 17 4 12"/>
  </svg>
);

const XIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
  </svg>
);

/* ── COMPONENT ── */
const CookieConsent = () => {
  const [cookies, setCookie] = useCookies(['cookieConsent']);
  const [showPopup, setShowPopup]       = useState(false);
  const [agreementText, setAgreementText] = useState('');
  const [isLoading, setIsLoading]       = useState(false);
  const userid  = localStorage.getItem('userid');
  const navigate = useNavigate();

  useEffect(() => {
    chack_cookie();
    c();
  }, [cookies.cookieConsent]);

  /* ── fetch agreement text ── */
  const c = async () => {
    try {
      const res  = await fetch('https://addpay.net/e-member/public/api/user_condition', {
        method: 'POST', redirect: 'follow',
      });
      const data = await res.json();
      setAgreementText(data.agreement_text);
    } catch (err) {
      console.error('Error fetching data:', err);
    }
  };

  const chack_cookie = () => setShowPopup(true);

  /* ── accept ── */
  const handleAccept = async () => {
    setIsLoading(true);
    setCookie('cookieConsent', 'accepted', { path: '/' });

    try {
      const res = await fetch(`${API_ENDPOINT_USER}/e-member/public/api/user_agreement`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ user_id: userid, action: 'insert' }),
        redirect: 'follow',
      });
      const result = await res.json();
      console.log(result);
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoading(false);
      setShowPopup(false);
    }
  };

  /* ── decline ── */
  const handleDecline = () => {
    setCookie('cookieConsent', 'declined', { path: '/' });
    navigate('/Home');
  };

  if (!showPopup) return null;

  return (
    <>
      <style>{css}</style>
      <div className="cc-overlay">
        <div className="cc-sheet" role="dialog" aria-modal="true" aria-labelledby="cc-title">

          {/* DRAG HANDLE */}
          <div className="cc-handle"><span /></div>

          {/* HEADER */}
          <div className="cc-header">
            <div className="cc-badge">
              <ShieldIcon />
              นโยบายความเป็นส่วนตัว
            </div>
            <h2 className="cc-title" id="cc-title">
              ข้อตกลงและเงื่อนไขการใช้บริการ
            </h2>
            <p className="cc-subtitle">
              กรุณาอ่านและยืนยันการยอมรับข้อตกลงก่อนเข้าใช้งานระบบ
            </p>
          </div>

          {/* SCROLLABLE BODY */}
          <div className="cc-body">
            {agreementText
              ? <div dangerouslySetInnerHTML={{ __html: agreementText }} />
              : (
                /* skeleton loader */
                <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                  {[100, 85, 95, 70, 90, 60].map((w, i) => (
                    <div key={i} style={{
                      height: 14, borderRadius: 6,
                      background: 'linear-gradient(90deg,#f1f5f9 25%,#e2e8f0 50%,#f1f5f9 75%)',
                      backgroundSize: '200% 100%',
                      width: `${w}%`,
                      animation: `shimmer 1.4s ${i * 0.08}s infinite linear`,
                    }}/>
                  ))}
                  <style>{`@keyframes shimmer{from{background-position:200% 0}to{background-position:-200% 0}}`}</style>
                </div>
              )
            }
          </div>

          <div className="cc-scroll-hint">↑ เลื่อนขึ้นเพื่ออ่านรายละเอียดเพิ่มเติม</div>

          {/* FOOTER */}
          <div className="cc-footer">
            <p className="cc-footer-note">
              การกด <strong>"ยินยอม"</strong> หมายถึงคุณได้อ่านและยอมรับข้อตกลงทั้งหมดแล้ว
            </p>
            <div className="cc-btns">
              <button className="cc-btn-decline" onClick={handleDecline} disabled={isLoading}>
                <XIcon /> ไม่ยินยอม
              </button>
              <button className="cc-btn-accept" onClick={handleAccept} disabled={isLoading}>
                {isLoading
                  ? <span style={{ opacity: 0.8 }}>⏳ กำลังบันทึก…</span>
                  : <><CheckIcon /> ยินยอมและดำเนินการต่อ</>
                }
              </button>
            </div>
          </div>

        </div>
      </div>
    </>
  );
};

export default CookieConsent;